import { render } from "./room_list.vue?vue&type=template&id=1040c86e"
import script from "./room_list.vue?vue&type=script&lang=js"
export * from "./room_list.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/source/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__